import { MiddlewareAPI, isRejectedWithValue, Middleware } from "@reduxjs/toolkit";

import { reactPlugin } from "../appinsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

/**
 * Log a warning and show a notification!
 */
export const errorMiddleware: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    const aError: any = action.error;
    reactPlugin.trackException({
      error: aError,
      severityLevel: SeverityLevel.Error,
    });

    const payload: any = action.payload;
    const httpstatus = payload.originalStatus ?? payload.status;
    //if (DEV) {
    if (httpstatus === 403) {
      console.warn("Access denied", action);
      /* toaster.negative(
          <ErrorMsg
            message={'Access was denied for resource\n' + action.type}
            httpstatus={httpstatus}
          />,
          {
            autoHideDuration: 5000,
            overrides: {
              InnerContainer: {
                style: { width: '100%' },
              },
            },
          }
        );*/
    } else if (httpstatus === 400) {
      console.error("Bad Request", action);
      /*toaster.negative(
          <ErrorMsg
            message={payload.data}
            httpstatus={httpstatus}
          />,
          {
            autoHideDuration: 5000,
            overrides: {
              InnerContainer: {
                style: { width: '100%' },
              },
            },
          }
        );*/
    } else if (httpstatus === 401) {
      console.warn("Access denied", action);
      /*toaster.negative(
          <ErrorMsg
            message={'Access was denied for resource\n' + action.type}
            httpstatus={httpstatus}
          />,
          {
            autoHideDuration: 3000,
            overrides: {
              InnerContainer: {
                style: { width: '100%' },
              },
            },
          }
        );*/
    } else if (httpstatus === 500) {
      console.error("An error occured in Backend", action);
      /*toaster.negative(
          <ErrorMsg
            message={payload.data}
            httpstatus={httpstatus}
          />,
          {
            autoHideDuration: 3000,
            overrides: {
              InnerContainer: {
                style: { width: '100%' },
              },
            },
          }
        );*/
    } else if (httpstatus === 503) {
      console.warn("The backend service is currently not running", action);
      /*toaster.negative(
          <ErrorMsg
            message={
              'The backend service is currently not running - please retry'
            }
            httpstatus={httpstatus}
          />,
          {
            autoHideDuration: 3000,
            overrides: {
              InnerContainer: {
                style: { width: '100%' },
              },
            },
          }
        );*/
    } else {
      console.error("Error call backend", action);
      /*if (aError?.data?.message) {
          //console.warn('Error call backend' + action.payload.status + action.error.data.message)
          toaster.negative(
            <ErrorMsg
              message={
                'Error call backend.\n' + payload.status + aError.data?.message
              }
              httpstatus={httpstatus}
            />,
            {
              autoHideDuration: 5000,
              overrides: {
                InnerContainer: {
                  style: { width: '100%' },
                },
              },
            }
          );
        } else {
          //console.error('Error call backend' + action.payload.status + action.type)
          toaster.negative(
            <ErrorMsg
              message={
                <ErrorMsg
                  message={
                    'Error call backend.\n' +
                    payload.status +
                    aError.data?.message
                  }
                  httpstatus={httpstatus}
                />
              }
              httpstatus={httpstatus}
            />,
            {
              autoHideDuration: 3000,
              overrides: {
                InnerContainer: {
                  style: { width: '100%' },
                },
              },
            }
          );
        }*/
    }
    //}
  }
  return next(action);
};
